/**
* BEGIN: add parentVariantId cart attribute
**/
// const parentVariantId = "gid://shopify/ProductVariant/50923746951495";
// // Function to update cart attributes
// function updateCartAttributes() {
//   fetch('/cart/update.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       attributes: {
//         parentVariantId: parentVariantId,
//       },
//     }),
//   });
// }
// updateCartAttributes();

/**
* BEGIN: back in stock notification logic
**/
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.back-in-stock-trigger').forEach(button => {
    button.addEventListener('click', function() {
      this.nextElementSibling.style.display = 'block';
    });
  });

  document.querySelectorAll('.back-in-stock-form').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const email = form.querySelector('[name="email"]').value;
      const product_handle = form.dataset.productHandle;
      const variantId = form.dataset.productVariantId;
      const publicApiKey = "U9b92a";

        const payload = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email
                            }
                        }
                    },
                    "channels": ["EMAIL"]
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": `$shopify:::$default:::${variantId}`
                        }
                    }
                }
            }
        };

      try {
          const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${publicApiKey}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "revision": "2024-06-15"
            },
            body: JSON.stringify(payload),
          });

          form.style.display = 'none';
          form.nextElementSibling.style.display = 'block';
        } catch (error) {
          console.error("Error: ", error);
        }
    });
  });

  document.querySelectorAll('.modal-close').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const modal = closeBtn.closest('.back-in-stock-modal');
      if (modal) {
        modal.style.display = 'none';

        // Optional: reset form and success message when closing
        const form = modal.querySelector('.back-in-stock-form');
        const success = modal.querySelector('.success-message');
        if (form) {
          form.style.display = 'block';
          form.reset();
        }
        if (success) {
          success.style.display = 'none';
        }
      }
    });
  });
});

/**
* BEGIN: remove duplicate loox badge globally
**/
$(document).ready(function () {
    $('.header__cart-link').on('click', function () {
        if (window.Rebuy && window.Rebuy.SmartCart) {
            Rebuy.Cart.fetchCart();
            Rebuy.SmartCart.show();
        } else {
            console.error('Rebuy Cart is not available.');
        }
    });

    function removeLooxBadge() {
        const looxBadge = $("#shopify-block-loox_reviews_loox_trust_badge_Hkyayw");
        if (looxBadge) {
            looxBadge.hide();
        }
    }
    removeLooxBadge();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                removeLooxBadge();
            }
        });
    });

    // Start observing the document body for changes in the child elements
    observer.observe(document.body, { childList: true, subtree: true });
});

// accordion script
$(document).ready(function () {
    // Select only top-level <details> elements with the 'accordion' class
    const topLevelDetails = document.querySelectorAll('details.main-accordion');

    topLevelDetails.forEach(detail => {
        detail.addEventListener('toggle', function () {
            if (this.open) {
                topLevelDetails.forEach(otherDetail => {
                    if (otherDetail !== this) {
                        otherDetail.removeAttribute('open');
                    }
                });
            }
        });
    });
});

// DISCOUNT CODE CHECK
$(document).ready(function () {
  document.addEventListener('rebuy:smartcart.ready', (event) => {
      $(document).on('click', '.rebuy-cart__discount-form .rebuy-button', function (e) {
        checkDiscountFunction();
      });
    });
});

// Function to Check if Discount Code
function checkDiscountFunction(event) {
    $('.dynamic_discount_error').remove();
    //e.preventDefault();
    var shopify_Locale_Lang = window.Shopify.locale;

    var discount_code = $('#rebuy-cart__discount-input').val();

    fetch(`https://giftcard.dr-emiskin.de/index.php?discount_code=${discount_code}`)
        .then(response => response.json()) // Parse the response as JSON
        .then(data => {
            // Check if success is true and gift_cards array is not empty Valid voucher code
            if (data.success === true && data.data.gift_cards && data.data.gift_cards.length > 0) {
                setTimeout(() => {
                    if (shopify_Locale_Lang === 'en') {
                        $('.rebuy-cart__discount-error-message').html('&#9432; Gift cards redeemable at checkout');
                    } else {
                        $('.rebuy-cart__discount-error-message').html('&#9432; Geschenkkarten im Checkout einlösbar');
                    }
                }, 1000);
            } else {
                return true;
            }
        })
        .catch(err => {
            console.error('Error creating variant:', err);
        });
    return true;
}
/**
* BEGIN: REBUY CUSTOM SCRIPTS
*/
document.addEventListener('DOMContentLoaded', function () {
    //get Current Location
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var shippingCost = 0;
    var country = "Unknown";
    var locale_lang = window.Shopify.locale;

    if (locale_lang == 'en') {
        $('.tool-tip-msg').text('&#9432; Gift cards redeemable at checkout');
    } else {
        $('.tool-tip-msg').text('&#9432; Geschenkkarten im Checkout einlösbar');
    }
    // Function to determine shipping cost based on country
    function getCountryAndShippingCost() {
        // Check for Germany
        if (timeZone === "Europe/Berlin") {
            country = "Germany";
            shippingCost = 4.95;
        }
        // Check for Austria
        else if (timeZone === "Europe/Vienna") {
            country = "Austria";
            shippingCost = 5.95;
        }
        // Check for other EU countries (a selection of common EU time zones)
        else if (["Europe/Paris", "Europe/Rome", "Europe/Madrid", "Europe/Amsterdam", "Europe/Brussels",
            "Europe/Warsaw", "Europe/Stockholm", "Europe/Copenhagen", "Europe/Bucharest",
            "Europe/Helsinki", "Europe/Lisbon"].includes(timeZone)) {
            country = "EU Country";
            shippingCost = 12.95;
        }
        else {
            country = "Non-EU Country";
            shippingCost = 15.65;
        }

      return {
        country,
        shippingCost
      };
    }
    async function updateCartEstimate(event) {
        try {
            // Fetch the latest cart data
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();

            const cartTotal = cart.total_price / 100;

            // Determine country and shipping cost
            let {country, shippingCost} = getCountryAndShippingCost();

            // Adjust shipping cost based on the cart total
            if (cartTotal > 60 && (country === 'Germany' || country === 'Austria')) {
                shippingCost = 0;
            } else if (cartTotal > 150) {
                shippingCost = 0;
            }

            const estFinalPrice = cartTotal + shippingCost;

            // Function to format the currency to Euro
            const formatCurrency = (value) => value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
            const formattedShippingCost = shippingCost > 0 ? formatCurrency(shippingCost) : 'Free';
            const formattedEstFinalPrice = formatCurrency(estFinalPrice);
            const dynamicCoinVal = cartTotal;

            // Update the UI with shipping cost and final price
            const shippingMessageDiv = document.querySelector('.rebuy-cart__flyout-shipping-message');
            const finalPriceDiv = document.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
            const dynamicCoinDiv = document.querySelector('.dynamic-coin');

            if (shippingMessageDiv) {
                shippingMessageDiv.innerHTML = formattedShippingCost;
            }
            if (finalPriceDiv) {
                finalPriceDiv.innerHTML = formattedEstFinalPrice;
            }
            if (dynamicCoinDiv) {
                dynamicCoinDiv.innerHTML = dynamicCoinVal;
            }

        } catch (error) {
            console.error('Error in updateCartEstimate:', error);
        }
    }

    // Function to update the cart estimate when a product is added
    async function updateCartEstimateProductAdd(event) {
        try {
            // Fetch the latest cart data
            const response = await fetch('/cart.js');
            const cart = await response.json();

            // Get the cart total
            const cartTotal = cart.total_price / 100;

            let {country, shippingCost} = getCountryAndShippingCost();

            // Adjust shipping cost based on the cart total
            if (cartTotal > 60 && (country === 'Germany' || country === 'Austria')) {
                shippingCost = 0;
            } else if (cartTotal > 150) {
                shippingCost = 0;
            }
            const estFinalPrice = cartTotal + shippingCost;

            // Function to format the currency to Euro
            const formatCurrency = (value) =>
                value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
            const formattedShippingCost = shippingCost > 0 ? formatCurrency(shippingCost) : 'Free';
            const formattedEstFinalPrice = formatCurrency(estFinalPrice);
            const dynamicCoinVal = cartTotal;

            // Update the UI with shipping cost and final price
            const shippingMessageDiv = document.querySelector('.rebuy-cart__flyout-shipping-message');
            const finalPriceDiv = document.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
            const dynamicCoinDiv = document.querySelector('.dynamic-coin');

            if (shippingMessageDiv) {
                shippingMessageDiv.innerHTML = formattedShippingCost;
            }
            if (finalPriceDiv) {
                finalPriceDiv.innerHTML = formattedEstFinalPrice;
            }
            if (dynamicCoinDiv) {
                dynamicCoinDiv.innerHTML = dynamicCoinVal;
            }

        } catch (error) {
            console.error('Error fetching cart:', error);
        }
    }

    document.addEventListener("rebuy:smartcart.init", updateCartEstimate);
    document.addEventListener("rebuy:smartcart.ready", updateCartEstimate);
    document.addEventListener('rebuy:smartcart.show', updateCartEstimate);
    document.addEventListener("rebuy:smartcart.line-item-increase", updateCartEstimate);
    document.addEventListener("rebuy:smartcart.line-item-decrease", updateCartEstimate);
    document.addEventListener("rebuy:smartcart.line-item-removed", updateCartEstimate);
    document.addEventListener("rebuy:cart.add", updateCartEstimateProductAdd);


    function dynamicLanguageUpdate(event) {
        setTimeout(() => {
            //Get Current Language
            var shopify_Locale_Lang = window.Shopify.locale;
            //console.log('ShopifyLocale '+ShopifyLocale);
            if (shopify_Locale_Lang == 'en') {
                // Hide elements with class 'lang-de'
                var hideElements = document.querySelectorAll('.lang-de');
                var hideElements_flex = document.querySelectorAll('.lang-de-flex');
                hideElements.forEach(function (element) {
                    element.style.display = 'none';
                });
                hideElements_flex.forEach(function (element) {
                    element.style.display = 'none';
                });
                // Show elements with class 'lang-en'
                var showElements = document.querySelectorAll('.lang-en');
                var showElements_flex = document.querySelectorAll('.lang-en-flex');
                showElements.forEach(function (element) {
                    element.style.display = 'block';
                });
                showElements_flex.forEach(function (element) {
                    element.style.display = 'flex';
                });
            } else {
                // Hide elements with class 'lang-en'
                var hideElements = document.querySelectorAll('.lang-en');
                var hideElements_flex = document.querySelectorAll('.lang-en-flex');
                hideElements.forEach(function (element) {
                    element.style.display = 'none';
                });
                hideElements_flex.forEach(function (element) {
                    element.style.display = 'none';
                });
                // Show elements with class 'lang-de'
                var showElements = document.querySelectorAll('.lang-de');
                var showElements_flex = document.querySelectorAll('.lang-de-flex');
                showElements.forEach(function (element) {
                    element.style.display = 'block';
                });
                showElements_flex.forEach(function (element) {
                    element.style.display = 'flex';
                });
            }
        }, 100);
    }
    document.addEventListener('DOMContentLoaded', dynamicLanguageUpdate);
    document.addEventListener("rebuy:smartcart.init", dynamicLanguageUpdate);
    document.addEventListener("rebuy:smartcart.ready", dynamicLanguageUpdate);
    document.addEventListener('rebuy:smartcart.show', dynamicLanguageUpdate);
    document.addEventListener("rebuy:smartcart.line-item-increase", dynamicLanguageUpdate);
    document.addEventListener("rebuy:smartcart.line-item-decrease", dynamicLanguageUpdate);
    document.addEventListener("rebuy:smartcart.line-item-removed", dynamicLanguageUpdate);
    document.addEventListener("rebuy:cart.add", dynamicLanguageUpdate);
    // Detect DOM changes (New elements added or removed)
    var targetNode = document.body;
    var config = { childList: true, subtree: true }; // Watching for child nodes and subtree changes

    var observer = new MutationObserver(function (mutationsList, observer) {
        dynamicLanguageUpdate();  // Trigger function on any DOM change
    });

    observer.observe(targetNode, config);  // Start observing DOM

    document.addEventListener('click', function (event) {
        dynamicLanguageUpdate();  // Trigger function on any click

    });
});

/**
* END: REBUY CUSTOM SCRIPTS
*/
